import { render, staticRenderFns } from "./banner-list-description.vue?vue&type=template&id=3eb4af32"
import script from "./banner-list-description.vue?vue&type=script&lang=js"
export * from "./banner-list-description.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports